import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import TableComponent from "../../../shared/components/table";
import { RequestColumns } from "../../../shared/components/table/columns/requests";
import { SortingState } from "@tanstack/react-table";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  openCaseModal,
  setCaseDetailModal,
} from "../../../states/slices/globalReducer";
import CaseFolderDetailsModal from "./internals/case-folder/modals/CaseFolderDetailsModal";

const TABS = [
  "Join Request",
  "Change of Counsel Request",
  "Request For Certified True Copy",
  "Request For Record of Proceedings",
];

const MOCK_DATA = [
  {
    sn: false,
    date: "31-05-2024",
    title: "Olugbenga Akintola vs Israel Anyemalu",
    status: "Awaiting service",
    subject_matter: "Criminal Court",
    details: "View",
    appeal_number: "CV/304/2024",
    joinder_request: "Sent counsel...",
  },
  {
    sn: false,
    date: "31-05-2024",
    title: "Olugbenga Akintola vs Israel Anyemalu",
    status: "Awaiting service",
    subject_matter: "Criminal Court",
    details: "View",
    appeal_number: "CV/304/2024",
    joinder_request: "Sent counsel...",
  },
  // Add more rows if needed
];

function Requests() {
  const [activeTab, setActiveTab] = useState(TABS[0]);
  const [sorting, setSorting] = useState<SortingState>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const showCaseFolderDetails = useAppSelector(openCaseModal);
  const dispatch = useAppDispatch();

  return (
    <div className="flex flex-col h-full min-h-screen ">
      {/* Header */}
      <div className="bg-white px-8 py-6 border-b border-[#E9EAEB] flex flex-col gap-y-4">
        <h1 className="text-[28px] font-bold text-[#1A1A1A]">Request</h1>

        <div className="flex items-center gap-x-2 text-sm text-[#475467]">
          <Link
            to="/lawyer/overview"
            className="hover:text-[#00B074] transition-colors"
          >
            Home
          </Link>
          <span className="text-[#D0D5DD]">{">"}</span>
          <span className="font-medium text-[#1A1A1A]">Request</span>
        </div>
      </div>

      {/* Tabs */}
      <div className="px-8 pt-6 bg-white border-b border-[#E9EAEB]">
        <div className="flex items-center gap-x-8 overflow-x-auto scrollbar-hide">
          {TABS.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`pb-4 text-sm font-medium transition-colors whitespace-nowrap relative ${
                activeTab === tab
                  ? "text-[#00B074]"
                  : "text-[#667085] hover:text-[#344054]"
              }`}
            >
              {tab}
              {activeTab === tab && (
                <div className="absolute bottom-0 left-0 w-full h-[2px] bg-[#00B074] rounded-t-sm" />
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="p-8 flex flex-col gap-y-6">
        {/* Search */}
        <div className="relative w-full max-w-[300px]">
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-4 pr-10 py-2.5 rounded-lg border border-[#D0D5DD] focus:outline-none focus:border-[#00B074] focus:ring-1 focus:ring-[#00B074] bg-white text-sm placeholder:text-[#667085] shadow-sm"
          />
          <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#667085]" />
        </div>

        {/* Table */}
        <div className="bg-white  overflow-hidden">
          <TableComponent
            DATA={MOCK_DATA}
            // @ts-ignore
            COLUMNS={RequestColumns}
            sorting={sorting}
            setSorting={setSorting}
          />

          {/* Pagination */}
          <div className="flex items-center justify-end gap-x-4 mt-6 text-sm text-[#464255]">
            <span>Page 1 of 10</span>
            <div className="flex items-center gap-x-2">
              <button className="px-3 py-1.5 border border-[#E9EAEB] rounded hover:bg-gray-50">
                Previous
              </button>
              <button className="px-3 py-1.5 border border-[#E9EAEB] rounded hover:bg-gray-50">
                Next
              </button>
            </div>
            <div className="flex items-center gap-x-2">
              <span>Entries per page:</span>
              <select className="border border-[#E9EAEB] rounded p-1 focus:outline-none">
                <option>10</option>
                <option>20</option>
                <option>50</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <CaseFolderDetailsModal
        open={showCaseFolderDetails || false}
        close={() => dispatch(setCaseDetailModal(false))}
      />
    </div>
  );
}

export default Requests;
